// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { Option } from './Autocomplete';

export const getFieldOption = (field): Option | null => {
  return field.extra;
};

export const setFieldOption = (field, option: Option) => {
  if (option) {
    field.set('extra', option);
  }
};

export const resetFieldOption = (field) => {
  setFieldOption(field, { id: '', name: '' });
};